import { Stack, Typography } from "@mui/material";
import MentalWellbeingInfoCard from ".";

export default function MentalWellbeingInfoCardExamples() {
  return (
    <Stack gap={3} width="100%">
      <Typography variant="h6" fontWeight={600}>
        Both minimal (0 / 0)
      </Typography>
      <MentalWellbeingInfoCard
        depressionScore={0}
        anxietyScore={0}
        lastUpdated="2025-02-23T00:00:00Z"
        onCtaClick={() => {}}
      />

      <Typography variant="h6" fontWeight={600}>
        Moderate (1 / 2)
      </Typography>
      <MentalWellbeingInfoCard
        depressionScore={1}
        anxietyScore={2}
        lastUpdated="2025-02-23T00:00:00Z"
        onCtaClick={() => {}}
      />

      <Typography variant="h6" fontWeight={600}>
        Severe (4 / 5)
      </Typography>
      <MentalWellbeingInfoCard
        depressionScore={4}
        anxietyScore={5}
        lastUpdated="2025-02-23T00:00:00Z"
        onCtaClick={() => {}}
      />
    </Stack>
  );
}
